import { Column } from '@app/modules/table/classes/column.class';
import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';

export class NameColumn extends Column {
    title = 'time-tracking.myProjectsPage.table.project';
    property = 'project.name';
    sortField = 'project.name';
    type: CellDisplay = CellDisplay.string;
    sortable = true;
}
